import Enumerator from '../global/Enumerator';
import { HouseholdExpenseType } from './HouseholdExpense.enum';

export const householdDescriptions = [
  'food_and_supermarket_description',
  'coffees_lunches_takeaway_description',
  'entertainment_description',
  'domestic_holidays_description',
  'gym_fees_sport_other_health_and_wellness_description',
  'cigarettes_and_alcohol_description',
  'clothing_shoes_and_accessories_description',
  'hairdressing_and_grooming_description',
  'phone_internet_and_pay_tv_description',
  'media_streaming_and_subscription_services_description',
  'gifts_and_celebrations_description',
  'other_discretionary_expenses_description',
  'recreational_vehicle_running_costs_description',
  'pets_description',
  'public_education_costs_description',
  'private_education_costs_description',
  'tertiary_and_vocational_education_description',
  'childcare_description',
  'child_or_spousal_maintenance_description',
  'private_health_insurance_description',
  'doctor_dentist_pharmacy_glasses_description',
  'life_trauma_income_insurance_description',
  'essential_vehicle_running_cost_description',
  'public_transport_taxis_and_ride_share_commuting_airfares_description',
  'essential_vehicle_insurance_description',
  'current_rent_expense_description',
  'ongoing_board_expense_description',
  'primary_residence_running_costs_description',
  'primary_residence_body_corp_description',
  'secondary_residence_running_costs_description',
  'secondary_residence_body_corp_description',
  'investment_property_running_costs_description',
  'investment_property_body_corp_description'
];

export class HouseholdDescription extends Enumerator {
  static default() {
    return this.of('food_and_supermarket_description');
  }
}

HouseholdDescription.initEnum({
  food_and_supermarket_description: {
    get description() {
      return 'Groceries (food and non-alcoholic beverages), toiletries and cleaning products. In HEM.';
    },
    get descriptionNZ() {
      return 'Groceries (food and non-alcoholic beverages), toiletries and cleaning products.';
    },
    get type() {
      return HouseholdExpenseType.food_and_supermarket.name;
    }
  },
  coffees_lunches_takeaway_description: {
    get description() {
      return 'Take away food, coffee/tea and lunches. In HEM.';
    },
    get descriptionNZ() {
      return 'Take away food, coffee/tea and lunches.';
    },
    get type() {
      return HouseholdExpenseType.coffees_lunches_takeaway.name;
    }
  },
  entertainment_description: {
    get description() {
      return 'Dining and outings, gambling and other entertainment. In HEM.';
    },
    get descriptionNZ() {
      return 'Dining and outings, gambling and other entertainment.';
    },
    get type() {
      return HouseholdExpenseType.entertainment.name;
    }
  },
  domestic_holidays_description: {
    get description() {
      return 'Domestic holidays related travel and accommodation. In HEM.';
    },
    get descriptionNZ() {
      return 'Domestic holidays related travel and accommodation.';
    },
    get type() {
      return HouseholdExpenseType.domestic_holidays.name;
    }
  },
  gym_fees_sport_other_health_and_wellness_description: {
    get description() {
      return 'Gym and sport club memberships, yoga, pilates, health clubs and other wellness. In HEM.';
    },
    get descriptionNZ() {
      return 'Gym and sport club memberships, yoga, pilates, health clubs and other wellness.';
    },
    get type() {
      return HouseholdExpenseType.gym_fees_sport_other_health_and_wellness.name;
    }
  },
  cigarettes_and_alcohol_description: {
    get description() {
      return 'Cigarettes and alcohol purchases. In HEM.';
    },
    get descriptionNZ() {
      return 'Cigarettes and alcohol purchases.';
    },
    get type() {
      return HouseholdExpenseType.cigarettes_and_alcohol.name;
    }
  },
  clothing_shoes_and_accessories_description: {
    get description() {
      return 'Clothing, footwear and accessories (including travel goods, handbags, umbrellas, wallets, baby-goods) for men, women, children and infants, including purchases, repairs and alterations. In HEM.';
    },
    get descriptionNZ() {
      return 'Clothing, footwear and accessories (including travel goods, handbags, umbrellas, wallets, baby-goods) for men, women, children and infants, including purchases, repairs and alterations.';
    },
    get type() {
      return HouseholdExpenseType.clothing_shoes_and_accessories.name;
    }
  },
  hairdressing_and_grooming_description: {
    get description() {
      return 'Personal care items such as hairdressing, manicure, tanning, inc personal care products, cosmetics, hair services. In HEM.';
    },
    get descriptionNZ() {
      return 'Personal care items such as hairdressing, manicure, tanning, inc personal care products, cosmetics, hair services.';
    },
    get type() {
      return HouseholdExpenseType.hairdressing_and_grooming.name;
    }
  },
  phone_internet_and_pay_tv_description: {
    get description() {
      return 'Fixed and mobile phone, home and mobile internet, Pay TV subscription. In HEM.';
    },
    get descriptionNZ() {
      return 'Fixed and mobile phone, home and mobile internet, Pay TV subscription.';
    },
    get type() {
      return HouseholdExpenseType.phone_internet_and_pay_tv.name;
    }
  },
  media_streaming_and_subscription_services_description: {
    get description() {
      return 'Streaming services such as Spotify, Netflix, Kayo, sport streaming. In HEM.';
    },
    get descriptionNZ() {
      return 'Household expense for KiwiSaver payments.';
    },
    get type() {
      return HouseholdExpenseType.media_streaming_and_subscription_services.name;
    }
  },
  gifts_and_celebrations_description: {
    get description() {
      return 'Gifts and expenses related to birthdays, milestones and other celebrations. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Gifts and expenses related to birthdays, milestones and other celebrations.';
    },
    get type() {
      return HouseholdExpenseType.gifts_and_celebrations.name;
    }
  },
  other_discretionary_expenses_description: {
    get description() {
      return 'Overseas holidays related travel and accommodation; Other ongoing or recurring items not included within the other categories. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Overseas holidays related travel and accommodation; Donations and other ongoing or recurring items not included within the other categories.';
    },
    get type() {
      return HouseholdExpenseType.other_discretionary_expenses.name;
    }
  },
  recreational_vehicle_running_costs_description: {
    get description() {
      return 'Motorbike, boat, caravan insurance. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Fuel, tolls and parking.';
    },
    get type() {
      return HouseholdExpenseType.recreational_vehicle_running_costs.name;
    }
  },
  pets_description: {
    get description() {
      return 'Pet food, grooming, minding services, care products, health products, veterinarian fees. In HEM.';
    },
    get descriptionNZ() {
      return 'Pet food, grooming, minding services, care products, health products, veterinarian fees.';
    },
    get type() {
      return HouseholdExpenseType.pets.name;
    }
  },
  public_education_costs_description: {
    get description() {
      return 'Public or government, primary and secondary school tuition, school and sports fees including compulsory kindergarten/reception/pre-primary/prep. In HEM.';
    },
    get descriptionNZ() {
      return 'Public or government, primary and secondary school tuition, school and sports fees including compulsory kindergarten/reception/pre-primary/prep.';
    },
    get type() {
      return HouseholdExpenseType.public_education_costs.name;
    }
  },
  private_education_costs_description: {
    get description() {
      return 'Private education fees, private education uniforms. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Private education fees, private education uniforms.';
    },
    get type() {
      return HouseholdExpenseType.private_education_costs.name;
    }
  },
  tertiary_and_vocational_education_description: {
    get description() {
      return 'Higher education and vocational training fees (including TAFE, business college, drama, music, dance) excluding HECS, and professional fees (union dues, professional association subscriptions, legal, accountant and tax agent fees). In HEM.';
    },
    get descriptionNZ() {
      return 'Higher education and vocational training fees (including TAFE, business college, drama, music, dance) excluding HECS, and professional fees (union dues, professional association subscriptions, legal, accountant and tax agent fees).';
    },
    get type() {
      return HouseholdExpenseType.tertiary_and_vocational_education.name;
    }
  },
  childcare_description: {
    get description() {
      return 'Childcare including nannies and non-compulsory pre-school. In HEM.';
    },
    get descriptionNZ() {
      return 'Childcare including nannies and non-compulsory pre-school.';
    },
    get type() {
      return HouseholdExpenseType.childcare.name;
    }
  },
  child_or_spousal_maintenance_description: {
    get description() {
      return 'Maintenance for either dependent or non-dependent children, and spousal or de facto partner maintenance. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Maintenance for either dependent or non-dependent children, and spousal or de facto partner maintenance.';
    },
    get type() {
      return HouseholdExpenseType.child_or_spousal_maintenance.name;
    }
  },
  private_health_insurance_description: {
    get description() {
      return 'Health insurance including hospital, medical and dental insurance. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Health insurance including hospital, medical and dental insurance.';
    },
    get type() {
      return HouseholdExpenseType.private_health_insurance.name;
    }
  },
  doctor_dentist_pharmacy_glasses_description: {
    get description() {
      return 'Medical and health care services including GPs, specialists, physiotherapists, chiropractors, and opticians. Medicines, pharmaceuticals, prescriptions, glasses, purchase or hire of therapeutic appliances and equipment, hospital charges, nursing home charges. Excludes health insurance and ambulance insurance. In HEM.';
    },
    get descriptionNZ() {
      return 'Medical and health care services including GPs, specialists, physiotherapists, chiropractors, and opticians. Medicines, pharmaceuticals, prescriptions, glasses, purchase or hire of therapeutic appliances and equipment, hospital charges, nursing home charges. Excludes health insurance and ambulance insurance.';
    },
    get type() {
      return HouseholdExpenseType.doctor_dentist_pharmacy_glasses.name;
    }
  },
  life_trauma_income_insurance_description: {
    get description() {
      return 'Life insurance, TPD, Trauma insurance, income insurance, mortgage protection insurance. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Life insurance, TPD, Trauma insurance, income insurance, mortgage protection insurance.';
    },
    get type() {
      return HouseholdExpenseType.life_trauma_income_insurance.name;
    }
  },
  essential_vehicle_running_cost_description: {
    get description() {
      return 'Running costs for essential vehicles including fuel, servicing, repairs, parking, tolls (excludes insurance) and registration of motor vehicles (excludes recreational vehicles such as caravans, trailers, motorcycles, boats and aircraft). In HEM.';
    },
    get descriptionNZ() {
      return 'Rego, repairs and maintenance';
    },
    get type() {
      return HouseholdExpenseType.essential_vehicle_running_cost.name;
    }
  },
  public_transport_taxis_and_ride_share_commuting_airfares_description: {
    get description() {
      return 'Public transport, commuting airfares, taxi, ride share and care share. In HEM.';
    },
    get descriptionNZ() {
      return 'Public transport, commuting airfares, taxi, ride share and care share.';
    },
    get type() {
      return HouseholdExpenseType.public_transport_taxis_and_ride_share_commuting_airfares.name;
    }
  },
  essential_vehicle_insurance_description: {
    get description() {
      return 'General basic insurances include ambulance, car (not recreation vehicles), travel, and personal belongings insurance. Excludes property (house and contents), health, sickness and personal accident, life, income protection and pet insurance. In HEM.';
    },
    get descriptionNZ() {
      return 'General basic insurances include ambulance, car (not recreation vehicles), travel, and personal belongings insurance. Excludes property (house and contents), health, sickness and personal accident, life, income protection and pet insurance.';
    },
    get type() {
      return HouseholdExpenseType.essential_vehicle_insurance.name;
    }
  },
  current_rent_expense_description: {
    get description() {
      return 'Current rent paid. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Current rent paid.';
    },
    get type() {
      return HouseholdExpenseType.current_rent_expense.name;
    }
  },
  ongoing_board_expense_description: {
    get description() {
      return 'Ongoing board paid. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Ongoing board paid.';
    },
    get type() {
      return HouseholdExpenseType.ongoing_board_expense.name;
    }
  },
  primary_residence_running_costs_description: {
    get description() {
      return 'Costs associated with the primary residence, either owned or rented. Includes body corporate fees, strata fees, rates, water, sewage, repairs and maintenance, electricity, gas, heating oil and wood for fuel, purchase, hire and repair of household and outdoor furnishings and equipment, furnishings, floor coverings, linen, tableware, gardening tools, power tools, electrical, lights, trees, shrubs, plants, pool chemicals, home insurance, contents insurance and appliance insurance. Excludes land tax. In HEM.';
    },
    get descriptionNZ() {
      return 'Council rates or body corporate fees.';
    },
    get type() {
      return HouseholdExpenseType.primary_residence_running_costs.name;
    }
  },
  primary_residence_body_corp_description: {
    get description() {
      return 'Land tax on owner occupied principal place of residence. Excludes investment properties, secondary residences, and properties maintained for other purposes such as holiday properties or residences maintained for parents or children. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Body corporate fees, strata fees and land tax on owner occupied principal place of residence. Excludes investment properties, secondary residences, and properties maintained for other purposes such as holiday properties or residences maintained for parents or children.';
    },
    get type() {
      return HouseholdExpenseType.primary_residence_body_corp.name;
    }
  },
  secondary_residence_running_costs_description: {
    get description() {
      return 'Costs associated with any secondary residence, either rented or owned for non-investment purposes, such as a holiday property that is not rented to generate income, or a property that family members (parents or children) are allowed to live in rent-free. Includes property management fees, rates, water, sewage, repairs and maintenance, electricity, gas, heating oil and wood for fuel, purchase, hire and repair of household and outdoor furnishings and equipment, furnishings, floor coverings, linen, tableware, gardening tools, power tools, electrical, lights, trees, shrubs, plants, pool chemicals, landlords insurance, home insurance, contents insurance and appliance insurance. Not in HEM.';
    },
    get descriptionNZ() {
      return 'General property insurance';
    },
    get type() {
      return HouseholdExpenseType.secondary_residence_running_costs.name;
    }
  },
  secondary_residence_body_corp_description: {
    get description() {
      return 'Body corporate fees, strata fees and land tax on secondary residence. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Utilities and home repairs and maintenance (excludes telephone, internet and pay TV)';
    },
    get type() {
      return HouseholdExpenseType.secondary_residence_body_corp.name;
    }
  },
  investment_property_running_costs_description: {
    get description() {
      return 'Costs associated with any property owned for investment purposes. Includes property management fees, rates, water, sewage, repairs and maintenance, electricity, gas, heating oil and wood for fuel, purchase, hire and repair of household and outdoor furnishings and equipment, furnishings, floor coverings, linen, tableware, gardening tools, power tools, electrical, lights, trees, shrubs, plants, pool chemicals, landlords insurance, home insurance, contents insurance and appliance insurance. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Costs associated with any property owned for investment purposes. Includes property management fees, rates, water, sewage, repairs and maintenance, electricity, gas, heating oil and wood for fuel, purchase, hire and repair of household and outdoor furnishings and equipment, furnishings, floor coverings, linen, tableware, gardening tools, power tools, electrical, lights, trees, shrubs, plants, pool chemicals, landlords insurance, home insurance, contents insurance and appliance insurance.';
    },
    get type() {
      return HouseholdExpenseType.investment_property_running_costs.name;
    }
  },
  investment_property_body_corp_description: {
    get description() {
      return 'Body corporate fees, strata fees and land tax on investment property. Not in HEM.';
    },
    get descriptionNZ() {
      return 'Body corporate fees, strata fees and land tax on investment property.';
    },
    get type() {
      return HouseholdExpenseType.investment_property_body_corp.name;
    }
  }
});

export default {
  householdDescriptions,
  HouseholdDescription
};
